(function ($) {
  DJ.addBehavior('textAreaAutoHeight', '.comment-comment-form textarea', {
    attach: function () {
      const textArea = this;
      const enableScrollClass = 'textarea--with-scroll';

      /**
       * Increase textarea height depending on the amount of text.
       */
      const autoResize = () => {
        textArea.style.height = 'auto';
        textArea.style.height = `${textArea.scrollHeight}px`;

        if (textArea.scrollHeight >= 160) {
          textArea.classList.add(enableScrollClass);
        } else {
          textArea.classList.remove(enableScrollClass);
        }
      };

      /**
       * Call autoresize on the first init.
       * Add event listener with an autoResize function to
       * the textarea.
       */
      autoResize();
      textArea.addEventListener('input', autoResize, false);
    }
  });
})(jQuery);
